module.exports = __webpack_public_path__ + "media/images/ui__arrowUpInactive-2fd9bddfb1636072c5b59abb1ffc9628.png";